import React, { Fragment } from 'react';
import { Container, Row, Col } from "reactstrap";
import Verified from '../../../assets/verified.svg';
import '../../Steps/steps.scss';

function Sprint2Step5Successfull() {
	return (
    	<Fragment>
	        <section id="successfull-page">
	        	<nav className="header">
	        		<h3>Your first project!</h3>
	        		<span className="hamburger"></span>
	        	</nav>

	        	<Container className="builde-cont">
	        	<Row>
	        		<Col xs="{size: 12}">
						<div className="cont-success">
			        		<img src={Verified}/>
			        		<h1>Congrats!</h1>
			        		<p>Your project has been successfully created; now, top contractors will be competing for it</p>

			        		<a className="btn-white" href="#">Go to projects</a>
			        		<a className="btn-border-white" href="#">Back home</a>
			        	</div>
	        		</Col>
	        	</Row>
	        	</Container>
	        </section>
    	</Fragment>
    );
}

export default Sprint2Step5Successfull;